// removed by extract-text-webpack-plugin
module.exports = {"dotsButton":"qempo_DotsMenu_dotsButton-3Zkd3MN"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/DotsMenu/DotsMenu.scss
// module id = 1357
// module chunks = 0